module.exports = __webpack_public_path__ + "media/images/flags/32/Spain-c2755b1600a1bca9d0efeb1aa5ba0011.png";